import React, { Suspense, ComponentType } from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import { useAuth } from 'src/hooks/auth/useAuth';

interface SuspenseLoaderProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const SuspenseLoader: React.FC<SuspenseLoaderProps> = ({
  children,
  fallback
}) => {
  const { isLoading } = useAuth()

  if (isLoading) {
    return <div className='flex justify-center items-center h-screen w-screen'>
      <div className='flex flex-col items-center space-y-4 w-[200px]'>
        <img src={'/applogo.png'} />
        <div className="w-3/4 h-1 bg-blue-500/30 rounded-lg relative overflow-hidden">
          <span className="absolute inset-y-0 left-0 bg-blue-600 rounded-lg animate-bar1"></span>
          <span className="absolute inset-y-0 left-0 bg-blue-600 rounded-lg animate-bar2"></span>
        </div>
      </div>
    </div>
  }
  else {
    return (
      // <Suspense fallback={fallback || <LoadingSpinner fullScreen />}>
      <>
        {children}
      </>
      // </Suspense>
    );
  }
};

// Higher-order component for lazy loading with suspense
export function withSuspense<T extends {}>(
  Component: ComponentType<T>,
  fallback?: React.ReactNode
) {
  return (props: T) => (
    <SuspenseLoader fallback={fallback}>
      <Component {...props} />
    </SuspenseLoader>
  );
}